<!--
 * @Description: 医院详情dialog
 * @Author: gaohc, wanqian, sunhuihong
 * @Date: 2022-03-31 16:43:52
-->
<template>
  <div class="body">
    <el-dialog class="hsp-details-dialog" width="1000px" :title="dialogTitle" :visible.sync="visible"
      :close-on-click-modal="false" @open="initData" :before-close="handleCancel" center>
      <div class="dialog-body">
        <el-form ref="hspForm" class="hspForm" :model="hspFormData"
          :rules="rules" label-position="top" label-width="100px">
          <el-row style="margin: 0" :gutter="50" type="flex" justify="space-between">
            <el-col :span="8" style="text-align: left">
              <el-form-item label="全称：" prop="name">
                <el-input size="small" style="width: 100%" v-model.trim="hspFormData.name"
                  placeholder="请输入医院全称" :readonly="readonly" minlength="3"
                  @input="inputInstitutionName()">
								</el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="text-align: left">
              <el-form-item label="简称：">
                <el-input size="small" style="width: 100%" v-model.trim="hspFormData.simpleName"
                  placeholder="请输入医院简称" :readonly="readonly" maxlength="5">
								</el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="text-align: left">
              <el-form-item label="关联机构">
                <el-select size="small" style="width: 100%" v-model="hspFormData.institutionIdList"
                  multiple placeholder="请输入/选择机构"  collapse-tags
                  :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value,
										'institutionList', srcInstitutionList, this))"
                  @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible,
										'institutionList', srcInstitutionList, this)"
                  filterable :disabled="mode == 'edit' || mode == 'details'" clearable>
                  <el-option v-for="item in institutionList" :key="item.id" :value="item.id"
                    :disabled="item.status == 0 ? true : false"
                    :label="item.status ? item.name : item.name + '（禁用）'"/>
                </el-select>
                <div class="affiliate-inst" v-if="(hspData.adminType == 9 || hspData.adminType == 1) 
									&& mode != 'add' && hspFormData.simpleInstitutionList">
                  <span>已关联：</span>
                  <el-tooltip v-if="hspFormData.simpleInstitutionList.length"
                    class="item" effect="light" placement="right">
                    <div slot="content">
                      <div v-for="(i, idx) in hspFormData.simpleInstitutionList" :key="idx">
                        <span style="color: #657180; font-size: 14px; line-height: 22px;">
													{{ i.name }}
												</span>
                      </div>
                    </div>
                    <span class="inst-amount">
											{{ hspFormData.simpleInstitutionList.length }}家机构
										</span>
                  </el-tooltip>
                  <span v-else style="cursor: default" class="inst-amount">
										{{ hspFormData.simpleInstitutionList.length }}家机构
									</span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin: 0" :gutter="50" type="flex" justify="space-between">
            <el-col :span="8" style="text-align: left">
              <el-form-item label="省：" prop="province">
                <el-select size="small" style="width: 100%" v-model="hspFormData.province"
                  placeholder="请输入/选择省" :disabled="readonly" filterable
                  :filter-method="interactionUtil.debounce((value) => handleProvinceFilter(value))"
                  @visible-change="handleProvinceFilterVisibleChange"
                  @change="handleProvinceChange">
                  <el-option v-for="item in hspData.provinceList" :key="item.id"
                    :label="item.name" :value="item.name" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="text-align: left">
              <el-form-item label="市：" prop="city">
                <el-select size="small" style="width: 100%" v-model="hspFormData.city"
                  :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value,
										'dataCityList', srcCityList, this))"
                  @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(
										visible, 'dataCityList', srcCityList, this)"
                  placeholder="请输入/选择市" :disabled="readonly"
                  filterable @change="handleCityChange">
                  <el-option v-for="item in dataCityList" :key="item.id"
                    :label="item.name" :value="item.name" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="text-align: left">
              <el-form-item label="县：" prop="county">
                <el-select size="small" style="width: 100%" v-model="hspFormData.county"
                  :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value,
										'dataCountyList', srcCountyList, this))"
                  @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(
										visible, 'dataCountyList', srcCountyList, this)"
                  placeholder="请输入/选择县" :disabled="readonly"
                  filterable @change="handleCountyChange">
                  <el-option v-for="item in dataCountyList" :key="item.id"
                    :label="item.name" :value="item.name" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin: 0" :gutter="50" type="flex" justify="space-between">
            <el-col :span="8" style="text-align: left">
              <el-form-item label="规模：" prop="scaleText">
                <el-select size="small" style="width: 100%" @change="handleChangeScale"
                  v-model="hspFormData.scaleText" placeholder="请选择医院"
                  :disabled="readonly" filterable>
                  <el-option v-for="(item, key) in hspData.scaleMap" :key="key"
                    :label="item" :value="item" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="text-align: left">
              <el-form-item label="等级：" prop="gradeText">
                <el-select size="small" style="width: 100%" @change="handleChangeGrade"
                  v-model="hspFormData.gradeText" placeholder="请选择医院"
                  :disabled="readonly" filterable>
                  <el-option v-for="(item, key) in hspData.gradeMap" :key="key"
                    :label="item" :value="item" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="text-align: left">
              <el-form-item label="详细地址：" prop="addr">
                <el-input size="small" style="width: 100%" v-model.trim="hspFormData.addr"
                  placeholder="请输入医院地址" :readonly="readonly" @blur="blurAddress"
                  oninput="if(value.length > 100) value = value.slice(0,100)" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin: 0" :gutter="50" type="flex" justify="space-between">
            <el-col :span="16" style="text-align: left">
              <div style="width: 100%; height: 94%; position: relative">
                <div v-if="showMap" style="width: 100%; height: 94%" id="container"></div>
                <div class="toast-div" v-loading="showLocationLoading"
                  element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="定位中"
                  element-loading-spinner="el-icon-loading">
								</div>
              </div>
            </el-col>
            <el-col :span="8" style="text-align: left">
              <el-row :gutter="0" type="flex" justify="space-between">
                <el-form-item style="width: 100%" label="医院编号：" prop="identifier">
                  <el-input size="small" style="width: 100%" v-model.trim="hspFormData.identifier"
                    placeholder="" :disabled="true"
                    oninput="if(value.length > 100) value = value.slice(0,100)" />
              </el-form-item>
              </el-row>
              <el-row :gutter="0" type="flex" justify="space-between">
                <el-form-item style="width: 100%" label="经纬度：" prop="longitude">
                  <el-input size="small" style="width: 100%" v-model.trim="hspFormData.longitude"
                    placeholder="请输入医院的经度" :readonly="readonly" />
                </el-form-item>
              </el-row>
              <el-row :gutter="0" type="flex" justify="space-between">
                <el-form-item style="width: 100%" prop="latitude">
                  <el-input size="small" style="width: 100%" v-model.trim="hspFormData.latitude"
                    placeholder="请输入医院的纬度" :readonly="readonly" />
                </el-form-item>
              </el-row>
              <el-row :gutter="0" type="flex" justify="space-between" style="margin: 8px 0 0 0">
                <el-form-item style="width: 100%" label="半径 (米)：" prop="radius">
                  <el-input size="small" style="width: 100%" v-model.trim="hspFormData.radius" placeholder="请输入半径" 
                    :readonly="readonly" maxlength="4" @input="inputRadius" @change="changeRadius" />
                    <div style="font-size: 12px; color: #999999; line-height: 17px;">
                      系统判定半径{{hspFormData.radius}}m内即圆内的位置，都属于医院内
                    </div>
                </el-form-item>
              </el-row>
              <el-row style="margin: 8px 0 30px 0">
                <el-form-item style="width: 100%" label="客服：" prop="csr">
                  <el-row :gutter="10" type="flex" justify="space-between">
                    <el-col :span="24" style="text-align: left">
                      <el-input size="small" style="width: 100%" v-model.trim="hspFormData.csr"
                        placeholder="请输入客服姓名" :readonly="readonly"
                        oninput="if(value.length>25)value=value.slice(0,25)" />
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-row :gutter="0" type="flex" justify="space-between">
                  <el-form-item style="width: 100%" prop="csTeleno">
                    <el-input size="small" style="width: 100%" v-model.trim="hspFormData.csTeleno"
											@input="inputCsTeleno()" oninput="if(value.length>12)value=value.slice(0,12)"
                      placeholder="请输入客服电话" :readonly="readonly" />
                  </el-form-item>
                </el-row>
              </el-row>
              <el-row v-if="hspData.adminList && hspData.adminList.length">
                <el-form-item style="width: 100%" label="管理员：">
                  <el-row :gutter="10" type="flex">
                    <el-col :span="24" style="text-align: left">
                      <span v-for="(i, idx) in hspData.adminList" :key="idx"
                        @click="handleAdminItemClick(i.adminId)" class="admin-text">
												{{ (idx == hspData.adminList.length - 1 && i.name) || i.name + " , " }}
											</span>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>

          <el-row style="margin: 0" :gutter="50" type="flex" justify="space-between">
            <el-col :span="8" style="text-align: left">
              <el-form-item label="Logo：">
                <el-upload v-if="mode != 'details'" class="logo-uploader" ref="logoUpload"
                  accept="image/jpeg,image/png" action="" :show-file-list="false"
                  :auto-upload="false" :on-change="handleLogoChange">
                  <el-image v-if="!hspLogoFile && !hspFormData.logoPath" class="img-logo"
                    :src="logoPath" fit="contain">
									</el-image>
                  <div v-if="!hspLogoFile && !hspFormData.logoPath" style="color: #409eff;
										font-size: 12px; height: 15px; margin-top: -20px;">
                    点击上传
                  </div>
                  <div v-else style="width: 64px">
                    <el-image class="img-logo-file" :src="logoPath" fit="contain">
										</el-image>
                    <span class="text-hover" style="width: 64px">
											点击更换
										</span>
                  </div>
                </el-upload>
                <div v-else style="width: 64px; height: 64px; background-color: #ebeef2;
									display: flex; justify-content: center; align-items: center;">
                  <el-image
                    :style="{width: hspFormData.logoPath && hspFormData.logoPath.length ? '64px'
											: '30px', height: hspFormData.logoPath && hspFormData.logoPath.length
											? '64px' : '28px'}"
                    :src="logoPath" :preview-src-list="previewImgList1" fit="contain">
									</el-image>
                </div>
                <div v-if="mode != 'details'" class="tip-licensePath">
                  请上传宽度不小于100像素的图片，图片大小不超过
									<span class="tip-red">
										5M
									</span>
									，支持上传
									<span class="tip-red">
										png、jpg、jpeg
									</span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="text-align: left">
              <el-form-item label="医院主页图片：">
                <el-upload v-if="mode != 'details'" class="homepage-uploader" ref="homepageUpload"
                  accept="image/jpeg,image/jpg,image/png" action="" :show-file-list="false"
                  :auto-upload="false" :on-change="handlePicChange">
                  <el-image v-if="!hspPicFile && !hspFormData.picPath"
                    class="img-homepage" :src="picPath" fit="contain">
									</el-image>
                  <div v-if="!hspPicFile && !hspFormData.picPath" style="color: #409eff;
										font-size: 12px; height: 15px; margin-top: -25px;">
                    点击上传
                  </div>
                  <div v-else style="width: 100%">
                    <el-image class="img-homepage-file" :src="picPath" fit="contain">
										</el-image>
                    <span class="text-hover">
											点击更换
										</span>
                  </div>
                </el-upload>
                <div v-else style="width: 100%; height: 162px; background-color: #ebeef2;
									display: flex; justify-content: center; align-items: center;">
                  <el-image :style="{width: hspFormData.picPath && hspFormData.picPath.length
										? '100%' : '30px', height: hspFormData.picPath && hspFormData.picPath.length
										? '100%' : '28px'}" :src="picPath" :preview-src-list="previewImgList2" fit="contain">
									</el-image>
                </div>
                <div v-if="mode != 'details'" class="tip-licensePath">
                  请上传宽度不小于750像素的图片，图片大小不超过
									<span class="tip-red">
										5M
									</span>
									，支持上传
									<span class="tip-red">
										png、jpg、jpeg
									</span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8"></el-col>
          </el-row>
					
          <el-row style="margin: 15px 5px 0 5px" :gutter="50" type="flex" justify="space-between">
            <el-col :span="24" style="text-align: left">
              <el-form-item label="医院简介：" prop="description">
                <el-input style="width: 100%; margin-top: 10px" v-model="hspFormData.description"
                  placeholder="请输入医院简介" :readonly="readonly" type="textarea"
                  :rows="2" oninput="if(value.length>300)value=value.slice(0,300)" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin: 0" :gutter="50" type="flex" justify="space-between">
            <el-col :span="24" style="text-align: left">
              <el-form-item label="备注：" prop="remark">
                <el-input style="width: 100%; margin-top: 10px" v-model="hspFormData.remark"
                  placeholder="请输入备注信息" :readonly="readonly" type="textarea" :rows="2"
                  oninput="if(value.length>100)value=value.slice(0,100)" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin: 0" :gutter="50" type="flex" justify="space-between">
            <el-col v-if="mode == 'details'" :span="24" style="text-align: left">
              <el-form-item style="width: 100%" label="登陆地址：">
                <span>{{ hspData.landingUrl }}</span>
                <img style="margin-left: 15px; width: 20px; height: 20px" alt="" class="mouse-pointer"
                  src="@/assets/common/icon-common-copy.png" @click="handleCopyHospitalPageUrl" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="dialog-footer bk-wizard-bottons">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button v-if="mode != 'details'" type="primary" @click="submit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Constant from "@/global/Constant.js";
import Util from '@/global/Util.js'

export default {
  name: "HospitalDetails",
  props: ["visible", "mode", "hspId", "instId"],
  data() {
    return {
      hspData: {}, //接口Do返回data
      hspFormData: {}, //医院实体data

      // 医院相关select选择项
      institutionList: [],
      srcInstitutionList: [],
      dataCityList: [],
      dataCountyList: [],
      srcProvinceList: [],
      srcCityList: [],
      srcCountyList: [],

      rules: {
        name: [{required: true, message: "请输入医院名称", trigger: "blur"},
               {min: 3, message: "输入医院名称字数至少为3"}],
        scaleText: [{required: true, message: "请选择医院规模", trigger: ["blur"]}],
        identifier: [{required: true, message: "请输入医院编号", trigger: "blur"},
                     {min: 2, message: "输入医院编号字数至少为2"},
                     {max: 20, message: "输入医院编号字数最多为20"}],
        province: [{required: true, message: "请选择省", trigger: ["blur"]}],
        city: [{required: true, message: "请选择市", trigger: ["blur"]}],
        county: [{required: true, message: "请选择县", trigger: ["blur"]}],
        addr: [{required: true, message: "请输入地址", trigger: "blur"},
               {min: 5, message: "输入地址字数至少为5"},
               {max: 50, message: "输入地址字数最多为50"}],
        csr: [{required: true, message: "请输入客服姓名", trigger: "blur"},
              {min: 2, message: "输入客服姓名字数至少为2"},
              {max: 25, message: "输入客服姓名字数最多为25"}],
        csTeleno: [{required: true, message: "请输入客服电话号码", trigger: "blur"}],
        longitude: [{required: true, message: "请输入经度", trigger: "blur"}],
        latitude: [{required: true, message: "请输入纬度", trigger: "blur"}],
        gradeText: [{required: true, message: "请选择医院等级", trigger: ["blur"]}],
      },

      hspLogoFile: null,
      hspPicFile: null,

			//地图相关变量
      showMap: true,
      qq: null,
      qqMap: null,
      markerArr: [],
      circleArr: [],
      lat: "39.908821",
      lng: "116.397469",
      mapCallCount: 0,
      startMillis: 0,
      endMillis: 0,
      showLocationLoading: false,
    };
  },
  computed: {
    dialogTitle() {
      switch (this.mode) {
        case "add":
          return "新增医院";
        case "edit":
          return "编辑医院";
        case "details":
          return "医院详情";
        default:
          return "----";
      }
    },

    readonly() {
      return this.mode == "details";
    },

    //医院logo
    logoPath() {
      if (this.hspLogoFile) {
        return this.commonUtil.file2Url(this.hspLogoFile);
      }

      return this.hspFormData.logoPath ? this.commonUtil.fillUrlArgments
        (this.commonUrl.URL_DOWNLOAD_FILE, this.hspFormData.logoPath)
        : require("@/assets/common/img-common-chooseimg.png");
    },

    //医院主图
    picPath() {
      if (this.hspPicFile) {
        return this.commonUtil.file2Url(this.hspPicFile);
      }

      return this.hspFormData.picPath ? this.commonUtil.fillUrlArgments
        (this.commonUrl.URL_DOWNLOAD_FILE, this.hspFormData.picPath)
        : require("@/assets/common/img-common-chooseimg.png");
    },

    previewImgList1() {
      let imgList = [];
      if (this.hspFormData.logoPath) {
        imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE,
				this.hspFormData.logoPath));
      }
      return imgList;
    },

    previewImgList2() {
      let imgList = [];
      if (this.hspFormData.picPath) {
        imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE,
				this.hspFormData.picPath));
      }
      return imgList;
    }
  },
  methods: {
    //定位当前
    handleLocationCurrent() {
      this.startMillis = Date.parse(new Date());
      this.showLocationLoading = true;
      this.getUserLocation();
    },

    //选择省
    handleProvinceChange(value) {
      this.hspFormData.provinceId = Util.searchKeyWithValueInArr('name', value, this.hspData.provinceList).id;
      this.hspFormData.city = "";
      this.hspFormData.cityId = "";
      this.hspFormData.county = "";
      this.hspFormData.countyId = "";
      this.requsetCityList(this.hspFormData.provinceId);
      this.handleGeocoder();
    },

    handleProvinceFilter(value) {
      //统一转化为小写
      let lowerCaseValue = value.toLowerCase();
      this.hspData.provinceList = this.srcProvinceList.filter((item) =>
				item.name.indexOf(lowerCaseValue) != -1 || item.py.indexOf(lowerCaseValue) != -1);
    },

    handleProvinceFilterVisibleChange(visible) {
      if (visible) {
        this.hspData.provinceList = JSON.parse(JSON.stringify(this.srcProvinceList));
      }
    },

    //请求市数据
    requsetCityList(id) {
      let url = this.commonUtil.fillUrlArgments(this.commonUrl.URL_LIST_COMMON_CITY, id);
      this.appAxios("GET", url).then((result) => {
        if (result == null) {
					return
				}

				this.dataCityList = result.data;
				this.srcCityList = result.data;
      });
    },

    //选择市
    handleCityChange(value) {
      this.hspFormData.cityId = Util.searchKeyWithValueInArr('name', value, this.dataCityList).id;
      this.hspFormData.county = "";
      this.hspFormData.countyId = "";
      this.requsetCountyList(this.hspFormData.cityId);
      this.handleGeocoder();
    },

    //请求县数据
    requsetCountyList(id) {
      let url = this.commonUtil.fillUrlArgments(this.commonUrl.URL_LIST_COMMON_COUNTY, id);
      this.appAxios("GET", url).then((result) => {
        if (result == null) {
					return
				}

				this.dataCountyList = result.data;
				this.srcCountyList = result.data;
      });
    },

    //选择县
    handleCountyChange(value) {
      this.hspFormData.countyId = Util.searchKeyWithValueInArr('name', value, this.dataCountyList).id;
      this.handleGeocoder();
    },

    //详细地址输入完成
    blurAddress() {
      this.handleGeocoder();
    },

    //地址编码
    handleGeocoder() {
      let self = this;
      if (!self.hspFormData.addr || self.hspFormData.addr.length < 5) {
        return;
      }

      //这里地址若省市区有选项有值会拼接一起查
      let wholeAddress = "";
      if (self.hspFormData.province) wholeAddress = wholeAddress + self.hspFormData.province;

      if (self.hspFormData.city) wholeAddress = wholeAddress + self.hspFormData.city;

      if (self.hspFormData.county) wholeAddress = wholeAddress + self.hspFormData.county;

      wholeAddress = wholeAddress + self.hspFormData.addr;
      this.qqMapGeocoder(wholeAddress);
    },

    qqMapGeocoder(address) {
      Util.qqMapGeocoder(address).then(data => {
        let location = data.result.location;
        console.log('location----',location);
        this.lat = location.lat;
        this.lng = location.lng;
        this.$set(this.hspFormData, 'longitude', this.lng);
        this.$set(this.hspFormData, 'latitude', this.lat);
        this.qqMap.setCenter(new this.qq.maps.LatLng(this.lat, this.lng));
        this.setMapMaker(this.qqMap, new this.qq.maps.LatLng(this.lat, this.lng));
      }).catch(err => {
        console.log('err-----',err)
        this.$message("没有查找到当前地址的经纬度,请输入准确的详细地址");
        this.$set(this.hspFormData, 'longitude', '');
        this.$set(this.hspFormData, 'latitude', '');
      });
    },

    //选择等级
    handleChangeGrade(currentValue) {
      this.hspFormData.grade = this.searchKeyWithValueInMap(currentValue, this.hspData.gradeMap);
    },

    //选择规模
    handleChangeScale(currentValue) {
      this.hspFormData.scale = this.searchKeyWithValueInMap(currentValue, this.hspData.scaleMap);
    },

    // 输入半径
    inputRadius() {
      this.hspFormData.radius = this.commonUtil.filterDigitals(this.hspFormData.radius);
    },

    changeRadius() {
      if (this.hspFormData.latitude && this.hspFormData.longitude) {
        this.lat = this.hspFormData.latitude;
        this.lng = this.hspFormData.longitude;
      }
      this.setMapMaker(this.qqMap, new this.qq.maps.LatLng(this.lat, this.lng));
    },

    //提交信息
    submit() {
      this.$refs["hspForm"].validate((valid) => {
        if (!valid) return;
        let url = this.mode == "add" ? Constant.URL_SAVE_HOSPITAL_WITH_DETAILS
					: Constant.URL_UPDATE_HOSPITAL_WITH_DETAILS;
        let fileMap = new Map();
        if (this.hspLogoFile && this.hspLogoFile.raw) {
          fileMap.set("logoFile", this.hspLogoFile.raw);
        }
        if (this.hspPicFile && this.hspPicFile.raw) {
          fileMap.set("picFile", this.hspPicFile.raw);
        }
        let param = {'name': 'hospital', 'value': {...this.hspFormData}};
        let [header, esParams] = this.encryptionUtil.encryptAndSignObjectParam(
				  param, Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY, 
				  Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          url: url,
          method: this.mode == "add" ? "POST" : "PUT",
          contentType: this.commonConst.CNTYPE_JSON,
          header: header,
          param: esParams,
          files: fileMap
        };
        this.vueRequest(requestData).then((result) => {
          if (result == null) {
            return;
          }
					
          this.clearData();
          this.showMap = false;
          this.mode == "add" ? this.$emit("close-dialog", true, result.data)
            : this.$emit("close-dialog", true);
        });
      });
    },

    //传入值在字典中查找其key值并返回
    searchKeyWithValueInMap(value, map) {
      let keyResult = "";
      Object.keys(map).forEach(function (key) {
        if(value == map[key]){
          keyResult = key
        }
      });
      return keyResult;
    },

    //管理员跳转后台用户详情
    handleAdminItemClick(amninId) {
      this.$router.push({
        name: "bkuser",
        params: {
          adminId: amninId,
          type: "hspDetails",
        }
      });
    },

    handleCopyHospitalPageUrl() {
      this.commonUtil.copyTextToBoard(this, this.hspData.landingUrl);
    },

    handleCancel() {
      this.clearData();
      this.showMap = false;
      this.$emit("close-dialog", false);
    },

    async initData() {
      this.clearData();
      this.clearVaild();
      this.initMap();
      await this.queryData();
      //地图中心点设置
      if (this.mode != "add") {
        if (this.hspFormData.longitude && this.hspFormData.latitude) {
          this.lat = this.hspFormData.latitude;
          this.lng = this.hspFormData.longitude;
          this.qqMap.setCenter(new this.qq.maps.LatLng(this.lat, this.lng));
          this.setMapMaker(this.qqMap, new this.qq.maps.LatLng(this.lat, this.lng));
        }
      } else {
        this.handleLocationCurrent();
      }
    },

    initMap() {
      this.showMap = true;
      let _this = this;
      this.commonUtil.initQQMap(Constant.QQMAPWX_KEY).then((qq) => {
        _this.qq = qq;
        _this.qqMap = new _this.qq.maps.Map(document.getElementById("container"), {
          // 地图的中心地理坐标。
          center: new _this.qq.maps.LatLng(_this.lat, _this.lng),
          zoom: 17,
          mapTypeId: qq.maps.MapTypeId.ROADMAP, //设置地图样式详情参见MapType
        });
        
        _this.setMapMaker(_this.qqMap, new _this.qq.maps.LatLng(_this.lat, _this.lng));
      });
    },

    setMapMaker(map, position){
      this.clearCovers(this.markerArr);
      let marker = new this.qq.maps.Marker({
        map: map,
        position: position,
      });
      console.log('添加marker-----')
      this.markerArr.push(marker);
      console.log('markerArr-----', this.markerArr);
      this.setMapCircle(map, position);
    },

    setMapCircle(map, position){
      this.clearCovers(this.circleArr);
      let radius = this.hspFormData && this.hspFormData.radius ? parseFloat(this.hspFormData.radius) : 100;
      let circle = new this.qq.maps.Circle({
        center: position,
        radius: radius,
        strokeColor: '#000',
        strokeDashStyle: 'dash',
        map: map
      });
      console.log('添加circle-----')
      this.circleArr.push(circle);
      console.log('circleArr=====', this.circleArr);
    },

    // 清除覆盖物
    clearCovers(arr) {
      if (!arr || !arr.length) return;
      arr.forEach((item) => {
        item.setMap(null);
      });
    },

    getUserLocation() {
      let geolocation = new this.qq.maps.Geolocation(Constant.QQMAPWX_KEY, "key");
      // setTimeout(x =>{console.log("setTimeout");
      geolocation.getLocation(this.showPosition, this.showErr);
      // }, 6000);
    },

    showPosition(position) {
      this.showLocationLoading = false;
      this.endMillis = Date.parse(new Date());
      this.lat = position.lat;
      this.lng = position.lng;
      this.qqMap.setCenter(new this.qq.maps.LatLng(this.lat, this.lng));
      this.setMapMaker(this.qqMap, new this.qq.maps.LatLng(this.lat, this.lng));
    },

    showErr() {
      console.log("定位失败", ++this.mapCallCount);
      this.getUserLocation(); //定位失败再请求定位，测试使用
    },

    //输入医院名称
    inputInstitutionName() {
      if (this.hspFormData.name.length > 32) this.hspFormData.name = this.hspFormData.name.slice(0, 32);
			this.hspFormData.identifier = this.pinyin.getCamelChars(this.hspFormData.name);
    },

    //输入客服手机号
    inputCsTeleno() {
      this.hspFormData.csTeleno = this.commonUtil.filterDigitals(this.hspFormData.csTeleno, ["-"]);
    },

    //选择logo改变
    handleLogoChange(file) {
      let limitation = {
        maxSize: Constant.LIMIT_IMG_SIZE_5,
        maxWidth: 100.0,
        maxHeight: 0,
        extLimit: {
          limitType: 1,
          minRatio: 0.4,
          minRatioText: "100:40",
          maxRatio: 1.5,
          maxRatioText: "100:150",
        },
        returnData: {},
      };
      this.imgUtil.validateAndCompressImg(file, limitation).then((data) => {
        if (data.errorText && data.errorText.length) {
          this.$message.error(data.errorText);
        } else {
          this.hspLogoFile = file;
        }
      });
    },

    //选择医院主页改变
    handlePicChange(file) {
      let limitation = {
        maxSize: Constant.LIMIT_IMG_SIZE_5,
        maxWidth: 750.0,
        maxHeight: 0,
        extLimit: {
          limitType: 1,
          minRatio: 0.1,
          minRatioText: "100:10",
          maxRatio: 1.0,
          maxRatioText: "100:100",
        },
        returnData: {},
      };
      this.imgUtil.validateAndCompressImg(file, limitation).then((data) => {
        if (data.errorText && data.errorText.length) {
          this.$message.error(data.errorText);
        } else {
          this.hspPicFile = file;
        }
      });
    },

    //初始化打开时去除表单验证
    clearVaild() {
      this.$nextTick(() => {
        this.$refs["hspForm"].clearValidate();
      });
    },

    getPreviewImgList() {
      let imgList = [];
      if (this.hspFormData.logoPath) {
        imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE,
					this.hspFormData.logoPath));
      }

      if (this.hspFormData.picPath) {
        imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE,
					this.hspFormData.picPath));
      }
      return imgList;
    },

    //初始化数据
    queryData() {
      return new Promise((resolve) => {
        let url = "";
        switch (this.mode) {
          case "add":
            url = Constant.URL_GET_HOSPITALDO_ADD;
            break;
          case "edit":
            url = Constant.URL_GET_HOSPITALDO_UPDATE;
            break;
          case "details":
            url = Constant.URL_GET_HOSPITAL_WITH_DETAILS;
            break;
        }
        let params = this.mode == 'add' ? {} : {'id': this.hspId};
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: url,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };

        this.vueRequest(requestData).then((result) => {
          if (result == null) {
						return
					}

					this.hspData = result.data;
					this.srcProvinceList = this.hspData.provinceList;
					this.institutionList = result.data.institutionList;
					this.srcInstitutionList = result.data.institutionList;
					this.hspFormData = result.data.hospital;
					if (this.hspFormData.provinceId) {
						this.requsetCityList(this.hspFormData.provinceId);
					}

					if (this.hspFormData.cityId) {
						this.requsetCountyList(this.hspFormData.cityId);
					}

          if (this.mode == 'add' && this.instId) {
            this.hspFormData.institutionIdList = [this.instId];
          }
					resolve();
        })
      });
    },

    clearData() {
      this.hspFormData = {};
      this.hspLogoFile = null;
      this.hspPicFile = null;
      this.lat = "39.908821";
      this.lng = "116.397469";
      if (this.qqMap) {
        this.qqMap.setCenter(new this.qq.maps.LatLng(this.lat, this.lng));
      }
      this.showLocationLoading = false;
      this.clearCovers(this.markerArr);
      this.clearCovers(this.circleArr);
      this.markerArr = [];
      this.circleArr = [];
    },
  },
};
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.hsp-details-dialog .el-dialog__header {
  text-align: center;
}

.hsp-details-dialog /deep/ .el-form--label-top .el-form-item__label {
  padding: 0px;
  line-height: 26px;
}

.logo-uploader {
  background-color: #ebeef2;
  width: 65px;
  height: 65px;
  text-align: center;
}

.homepage-uploader {
  background-color: #ebeef2;
  width: 100%;
  height: 65px;
  text-align: center;
}

.img-logo {
  width: 64px;
  height: 18px;
  margin-top: 13px;
}

.img-homepage {
  width: 64px;
  height: 26px;
  margin-top: 14px;
}

.img-logo-file {
  height: 64px;
  margin: 0px;
}

.img-homepage-file {
  height: 65px;
  margin: 0px;
}

.el-upload:hover .text-hover {
  display: block;
}

.text-hover {
  display: none;
  transform: translateY(-50%);
  font-size: 8px;
  color: black;
  text-align: center;
  z-index: 200;
  position: absolute;
  top: 36px;
  left: 0px;
  width: 100%;
}

.homepage-uploader .text-hover {
  top: 36px;
}

.admin-text {
  font-size: 14px;
  cursor: pointer;
  color: #3a7ff3;
}

.tip-red {
  color: #ff1515;
}

.tip-licensePath {
  margin-top: 11px;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
}

.dialog-footer {
  text-align: center;
}

.hspForm {
  margin-bottom: 60px;
}

.loading-wrap {
  text-align: center;
  color: #999;
  margin-bottom: 10px;
}

.affiliate-inst {
  line-height: 16px;
  margin-top: 10px;
  color: #657180;
  font-size: 14px;
  cursor: pointer;
}

.affiliate-inst .inst-amount {
  color: #3e7ef6;
}

.toast-div {
  height: 60px;
  width: 70px;
  position: absolute !important;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -45px;
  z-index: 300;
}
</style>



// WEBPACK FOOTER //
// src/components/hspmng/components/hospitalList/HospitalDetails.vue